import CodeByCategorySelectionComponent from "../../../components/codemaster/codemaster-category-search-select.component";
import DatePickerComponent from "../../../components/date-picker/date-picker.component";
import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import SelectSiteGroupComponent from "../../../components/site/select-site-group.component";
import SelectSiteSearchInputComponent from "../../../components/site/select-site-search-input.component";
import ViewBase from "../../view-base.view";
import CampaignListItemView from "./campaign-list-item.view";
import _ from "lodash";
import moment from "moment";
import { formats as FORMATS, codeMasterType } from "../../../config/constants";
import codeMasterModel from "../../../models/common/code-master.model";
import campaignModel from "../../../models/planogram/campaign.model";
import { Tooltip, PopoverPosition, Intent, Icons, Icon, MenuItem, Size, PopoverMenu } from "construct-ui";

export default function CampaignSearchView() {
  ViewBase.call(this);

  let viewCampaignDetails = (id) => { };
  let viewUpdateCampaignInfo = (id) => { };

  let isSelectedAll = false;
  let selectedCampaignList = [];
  let campaignList = [];
  let planogramTypeList = [];
  let isDownloadingFiles = [false, false];
  let isDownloadingMapping = {};
  let isDownloadingPPT = {};
  let statuses = [];

  const DEFAULT_FILTER_PARAMS = Object.freeze({
    planogramType: "",
    periodStart: moment().add(-6, 'months').format(FORMATS.apiDateFormat),
    periodEnd: moment().format(FORMATS.apiDateFormat),
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0,
    campaignName: "",
    status: {
      "sequence": "1",
      "code": "1",
      "name": "Active"
    },
    selectedSiteList: Object.freeze([]),
    selectedSiteGroupList: Object.freeze([]),
    selectedFxitures: Object.freeze([])
  });

  let filterParams = _.cloneDeep(DEFAULT_FILTER_PARAMS);
  // let lastSearchedFilterParams = _.cloneDeep(filterParams);

  const extractQueryParams = (params) => {
    // Only create key value pair when there is value
    const queryParam = Object.assign({},
      _.isEmpty(params.periodStart) ? null : { periodStart: params.periodStart },
      _.isEmpty(params.periodEnd) ? null : { periodEnd: params.periodEnd },
      !params.pageIndex ? null : { pageIndex: params.pageIndex },
      !params.pageSize ? null : { pageSize: params.pageSize },
      !params.planogramType ? null : { planogramTypeCode: params.planogramType.code },
      { campaignName: params.campaignName || '' },
      _.isEmpty(params.selectedSiteList) ? null : { siteID: params.selectedSiteList.map(x => x.siteId).join('^') },
      _.isEmpty(params.selectedSiteGroupList) ? null : { siteGroup: params.selectedSiteGroupList.map(g => g.code).join('^') },
      _.isEmpty(params.selectedFxitures) ? null : { fixtureName: params.selectedFxitures.map(g => g.code).join('^') }
    );

    if (!_.isEmpty(params.status) && params.status.code !== '') {
      queryParam.status = params.status.code;
    }
    // console.log('queryParam=========>', queryParam)
    return queryParam;
  };

  const getCampaignList = (viewState) => {
    this.showLoading();
    campaignList = [];

    // Reset Campaign selection
    isSelectedAll = false;
    selectedCampaignList.splice(0, selectedCampaignList.length);
    campaignModel.getCampaignList(extractQueryParams(filterParams)).then((result) => {
      // lastSearchedFilterParams = _.cloneDeep(filterParams);
      campaignList = result.data;
      filterParams.pageIndex = result.pageIndex;
      filterParams.pageSize = result.pageSize;
      filterParams.totalCount = result.total;
      this.hideLoading();

      viewState.saveState(campaignList, filterParams);
    }).catch((error) => {
      this.handleError(error);
    }).finally(() => {
      this.hideLoading();
    });
  };

  const _search = (viewState) => {
    filterParams.pageIndex = 1; // Always go back to page 1 
    getCampaignList(viewState);
  }

  const _clearFilter = (viewState) => {
    filterParams = _.cloneDeep(DEFAULT_FILTER_PARAMS);
    // Reload data
    getCampaignList(viewState);
  }

  const getPlanogramTypes = () => {
    codeMasterModel.getByCategoryV2({ category: codeMasterType.planogramType })
      .then(result => {
        planogramTypeList = result
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const getStatuses = () => {
    codeMasterModel.getByCategoryV2({ category: 'CommonStatus' })
      .then((result) => {
        statuses = result
      })
      .catch((error) => {
        this.handleError(error);
      })
  }

  const downloadRawData = () => {
    isDownloadingFiles[0] = true;
    const fileName = `Raw Data Campaign - ${moment().format('YYYYMMDDHHmm')}.xlsx`

    campaignModel.downloadRawData(
      fileName, selectedCampaignList)
      .catch((error) => { this.handleError(error); })
      .finally(() => { isDownloadingFiles[0] = false })
  }

  const downloadComplianceReport = () => {
    isDownloadingFiles[1] = true;
    const fileName = `Compliance by Sub Level - ${moment().format('YYYYMMDDHHmm')}.xlsx`

    campaignModel.downloadComplianceReport(fileName, selectedCampaignList)
      .catch((error) => { this.handleError(error) })
      .finally(() => { isDownloadingFiles[1] = false })
  }

  const downloadExcelForTargetResponse = (e) => {
    e.preventDefault();
    // wait for API
    return false;
  }

  const downloadExcelForCompliantElements = (campaignID) => {
    const fileName = `Elements Compliant - ${moment().format('YYYYMMDDHHmm')}.xlsx`
    campaignModel.downloadExcelForCompliantElements(fileName, campaignID)
      .catch((error) => { this.handleError(error) })
      .finally(() => { this.hideLoading() })
  }

  const downloadCampaignUploadedImagePPT = (campaignID) => {
    Object.assign(isDownloadingPPT, { [campaignID]: true });
    const fileName = `Campaign Compliance Image - ${moment().format('YYYYMMDDHHmm')}.pptx`
    const formData = new FormData()
    formData.append('campaignId', campaignID);
    campaignModel.downloadCampaignPPT(fileName, formData)
      .catch((error) => { this.handleError(error) })
      .finally(() => {
        this.hideLoading();
        Object.assign(isDownloadingPPT, { [campaignID]: false });
      })
  }

  const downloadFixtureSkuMapping = (campaignID) => {
    Object.assign(isDownloadingMapping, { [campaignID]: true });
    const fileName = `Campaign SKU Mapping - ${moment().format('YYYYMMDDHHmm')}.xlsx`
    let params = {
      campaignID: campaignID,
      siteID: null
    }
    campaignModel.downloadExcelForTargetResponse(fileName, params)
      .catch((error) => { this.handleError(error) })
      .finally(() => {
        this.hideLoading();
        Object.assign(isDownloadingMapping, { [campaignID]: false });
      })
  }

  const onPageSizeChanged = (pageIndex, pageSize, viewState) => {
    filterParams.pageIndex = pageIndex;
    filterParams.pageSize = pageSize;
    getCampaignList(viewState);
  }

  const onPageChanged = (pageIndex, viewState) => {
    filterParams.pageIndex = pageIndex;
    getCampaignList(viewState);
  }

  const updateFilter = (e) => {
    let prop = e.currentTarget.id;
    let value = e.currentTarget.value;
    if (prop && prop.length > 0) {
      filterParams[prop] = value
    }
  }

  const selectCampaign = (campaignID) => {
    if (selectedCampaignList.includes(campaignID)) {
      return
    }
    selectedCampaignList.push(campaignID);
  }

  const deselectCampaign = (campaignID) => {
    if (selectedCampaignList.includes(campaignID)) {
      isSelectedAll = false;
      selectedCampaignList.splice(selectedCampaignList.indexOf(campaignID), 1)
    }
  }

  const checkboxClickEvent = (campaignID, isChecked) => {
    if (isChecked) {
      selectCampaign(campaignID);
    } else {
      deselectCampaign(campaignID);
    }
  }

  const selectAllChanged = (e) => {
    if (e.target.checked) {
      isSelectedAll = true;
      campaignList.map(s => {
        if (!selectedCampaignList.includes(s.campaignID)) {
          selectedCampaignList.push(s.campaignID);
        }
      })
    } else {
      isSelectedAll = false;
      selectedCampaignList.splice(0, selectedCampaignList.length);
    }
    m.redraw();
  }

  const initState = (viewState) => {
    if (viewState.listDirty) {
      getCampaignList(viewState);
    } else {
      campaignList = _.cloneDeep(viewState.campaignList);
      filterParams = _.cloneDeep(viewState.filterParams);
    }
  };

  return {
    oninit: ({ attrs: { onViewCampaign, onEditClick, campaignViewState } }) => {
      if (onViewCampaign) {
        viewCampaignDetails = onViewCampaign;
      }
      if (onEditClick) {
        viewUpdateCampaignInfo = onEditClick;
      }
      initState(campaignViewState);

      // Filter dropdown options
      getPlanogramTypes();
      getStatuses();
    },
    view: (vnode) => {
      return [
        m('.col-12',
          // Search section
          m('.d-flex.flex-column.align-items-end.gap-2.mb-3',
            m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="false"]',
              m('i.bi.bi-filter'),
              this.getText("LT00000232", "Filter"),
            ),
            m('#search-section.card.collapse',
              { style: { width: '100%' } },
              m('.card-body',
                m('.row.g-3.align-items-end',
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00001198", "Image Type")),
                    m(SingleSelectComponent, {
                      selectedItem: filterParams.planogramType,
                      checkmark: true,
                      items: planogramTypeList,
                      filterable: false,
                      onSelect: e => {
                        filterParams.planogramType = e;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label[for=campaignName]', this.getText("LT00001201", "Campaign")),
                    m('input.form-control[id=campaignName]', { onchange: updateFilter, placeholder: this.getText("LT00001201", "Campaign"), value: filterParams.campaignName })
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000781", "Status")),
                    m(SingleSelectComponent, {
                      selectedItem: filterParams.status,
                      checkmark: true,
                      items: statuses,
                      filterable: false,
                      onSelect: e => {
                        filterParams.status = e;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label[for=period]', { style: { width: '100%' } }, m(".d-flex.justify-content-between",
                      m("div", this.getText("LT00000150", "Period"), m(Tooltip, {
                        content: m('span', "Default Period is past 6 months."),
                        hoverOpenDelay: 250,
                        openOnTriggerFocus: true,
                        position: PopoverPosition.AUTO,
                        trigger: m('i.bi.bi-info-circle.cursor-pointer.ps-1.me-0', { style: { 'color': '#FF9800' } })
                      })),
                      m(PopoverMenu, {
                        closeOnContentClick: true,
                        content: [
                          m(MenuItem, {
                            label: 'Past 6 months',
                            onclick: () => {
                              filterParams.periodStart = moment().add(-6, 'months').format(FORMATS.apiDateFormat);
                              filterParams.periodEnd = moment().format(FORMATS.apiDateFormat);
                            }
                          }),

                          m(MenuItem, {
                            label: 'Next 6 months',
                            onclick: () => {
                              filterParams.periodStart = moment().format(FORMATS.apiDateFormat);
                              filterParams.periodEnd = moment().add(6, 'months').format(FORMATS.apiDateFormat);
                            }
                          })
                        ],
                        menuAttrs: { size: Size.XS },
                        trigger: m(Icon, { name: Icons.SETTINGS, size: Size.XS, intent: Intent.PRIMARY, })
                      })
                    )),
                    m(DatePickerComponent, {
                      class: 'form-control',
                      isRange: true,
                      grid: 1,
                      calendars: 1,
                      type: "month",
                      dateStart: moment(filterParams.periodStart).format(FORMATS.dateFormat), // default date range
                      dateEnd: moment(filterParams.periodEnd).format(FORMATS.dateFormat), // default date range
                      readonly: true,
                      onselect: (e) => {
                        filterParams.periodStart = moment(e.detail.start).format(FORMATS.apiDateFormat);
                        filterParams.periodEnd = moment(e.detail.end).format(FORMATS.apiDateFormat);
                      }
                    })
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000071", "Site")),
                    m(SelectSiteSearchInputComponent, {
                      multiple: true,
                      selectedItems: filterParams.selectedSiteList,
                      onSelect: (s) => {
                        filterParams.selectedSiteList = s;
                      },
                    })
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText("LT00000072", "Site Group")),
                    m(SelectSiteGroupComponent, {
                      selectedItems: filterParams.selectedSiteGroupList,
                      onChange: (g) => {
                        filterParams.selectedSiteGroupList = g;
                      }
                    }),
                  ),
                  m('.col-lg-3.col-md-4.col-sm-6',
                    m('label.form-label', this.getText('LT00001197', 'Image Name')),
                    m(CodeByCategorySelectionComponent, {
                      id: 'Fixtures',
                      title: this.getText('LT00001197', 'Image Name'),
                      category: 'fixture',
                      selectedItems: filterParams.selectedFxitures,
                      onSelect: (selectedItems) => {
                        filterParams.selectedFxitures = selectedItems;
                      }
                    })
                  ),
                  // Search & clear buttons
                  m('.col-12.d-flex.justify-content-end.gap-2',
                    m('button.btn.btn-primary', {
                      onclick: () => {
                        _search(vnode.attrs.campaignViewState);
                      }
                    }, this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', {
                      onclick: () => {
                        _clearFilter(vnode.attrs.campaignViewState);
                      }
                    }, this.getText("LT00000031", "Clear")),
                  ),

                ),
              )
            ),
          ),
          // Campaign List
          m('.d-flex.justify-content-between.align-items-end.gap-3.mb-2',
            m('.form-check',
              m('input.form-check-input#select-all-Campaign[type=checkbox]', {
                checked: isSelectedAll,
                onchange: selectAllChanged,
                disabled: campaignList.length === 0
              }),
              m('label.form-check-label[for=select-all-Campaign]', this.getText("LT00000077", "Select all"))
            ),

            m('.d-flex',
              m('.input-group.w-auto.me-2',
                m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                  {
                    disabled: (campaignList && campaignList.length > 0) ? false : true,
                  },
                  isDownloadingFiles.includes(true)
                    ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
                    : m('i.bi.bi-file-earmark-arrow-down-fill'),
                  this.getText("LT00000492", "Download")
                ),
                m('ul.dropdown-menu',
                  m('li', {
                    title: selectedCampaignList.length === 0 ? this.getText("EM00000828", "Please select one or more campaigns") : '',
                  },
                    m('a.dropdown-item[href="javascript:void(0);"]', {
                      class: (isDownloadingFiles[0] || selectedCampaignList.length === 0) ? 'disabled' : '',
                      onclick: downloadRawData
                    },
                      isDownloadingFiles[0] &&
                      m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                      this.getText("LT00008050", "Raw Data")
                    )
                  ),
                  m('li', {
                    title: selectedCampaignList.length === 0 ? this.getText("EM00000369", "Please select one or more Campaigns") : '',
                  },
                    m('a.dropdown-item[href="javascript:void(0);"]', {
                      class: (isDownloadingFiles[1] || selectedCampaignList.length === 0) ? 'disabled' : '',
                      onclick: downloadComplianceReport
                    },
                      isDownloadingFiles[1] &&
                      m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                      this.getText("LT00001230", "Compliance by Sub Level")
                    )
                  ),
                ),
              ),
            ),
          ),
          m('.d-flex.flex-column.gap-2',
            campaignList && campaignList.length > 0
              ? campaignList.map((campaign) =>
                m(CampaignListItemView, {
                  viewUpdateCampaignInfo: () => { viewUpdateCampaignInfo(campaign.campaignID, campaign.campaignName) },
                  viewCampaignDetails: () => { viewCampaignDetails(campaign.campaignID, campaign.campaignName) },
                  downloadCampaignUploadedImagePPT: () => { downloadCampaignUploadedImagePPT(campaign.campaignID) },
                  onGoBack: vnode.attrs.onGoBack,
                  downloadExcelForCompliantElements: () => downloadExcelForCompliantElements(campaign.campaignID),
                  downloadExcelForTargetResponse: () => downloadExcelForTargetResponse(campaign.campaignID),
                  downloadFixtureSkuMapping: () => downloadFixtureSkuMapping(campaign.campaignID),
                  key: campaign.rowID,
                  isSelected: isSelectedAll || selectedCampaignList.includes(campaign.campaignID),
                  onCheckboxChange: (campaignID, isChecked) => checkboxClickEvent(campaignID, isChecked),
                  campaign: campaign,
                  isDownloadingMappingOrPPT: { mapping: isDownloadingMapping[campaign.campaignID], ppt: isDownloadingPPT[campaign.campaignID] }
                })
              )
              : m('.text-center.my-5', this.getText("EM00000141", "No records found."))
          ),
          campaignList && campaignList.length > 0 &&
          m(".mt-3",
            m(paginationComponent, {
              currentPage: filterParams.pageIndex,
              pageSize: filterParams.pageSize,
              totalItems: filterParams.totalCount,
              onPageChanged: (pageIndex) => { onPageChanged(pageIndex, vnode.attrs.campaignViewState) },
              onPageSizeChanged: (pageIndex, pageSize) => { onPageSizeChanged(pageIndex, pageSize, vnode.attrs.campaignViewState) }
            })
          )
        ),
        this.getBaseViews()
      ]
    },
  };
}
